import type * as React from 'react';
import { get } from '@Domain/Api';
import retentionSettingsFetched, {
	type RetentionSettingsFetchedAction,
	type RetentionSettingsPayload,
} from '@Application/Accounts/RetentionSettings/Actions/retentionSettingsFetched';
import retentionSettingsFetchFailed, {
	type RetentionSettingsFetchFailedAction,
} from '@Application/Accounts/RetentionSettings/Actions/retentionSettingsFetchFailed';
import type FetchRetentionSettings from '@Application/Accounts/RetentionSettings/Queries/FetchRetentionSettings';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = RetentionSettingsFetchedAction | RetentionSettingsFetchFailedAction;

export default (query: FetchRetentionSettings) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<RetentionSettingsPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/retention-settings`,
			);

			const action = retentionSettingsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = retentionSettingsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
